import * as mutation from "./mutation-types";
import * as action from "./action-types";
import { SHOW_NOTIFICATION } from "@/store/notifications/mutation-types";
import { GLOBAL_ERROR } from "@/store/system/mutation-types";
import { tableHelper } from "@/helpers/table.helper";
import * as ruleHelper from "@/helpers/rule.helper";
import { deepCopyAxiosException } from "@/store/helpers";
import axios from "axios";

export const actions = {
  async [action.LIST]({ commit, state }) {
    commit(mutation.LIST_STARTED);
    try {
      const url = tableHelper.constructUrl("/api/providers", state.listing.paging, state.listing.criteria);
      const { headers, data } = await axios.get(url);
      commit(mutation.LIST_SET_CRITERIA_DESCRIPTION, tableHelper.getCriteriaInfo(headers));
      commit(mutation.LIST_SET_PAGING, tableHelper.getPagingFromHeaders(headers));
      commit(mutation.LIST_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.LIST_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.LIST_NEXT_PAGE]({ state, commit, dispatch }) {
    commit(mutation.LIST_SET_PAGING, { page: state.listing.paging.page + 1 });
    await dispatch(action.LIST);
  },
  async [action.LIST_PREVIOUS_PAGE]({ state, commit, dispatch }) {
    commit(mutation.LIST_SET_PAGING, { page: state.listing.paging.page - 1 });
    await dispatch(action.LIST);
  },

  async [action.AUTOCOMPLETE]({ commit }, searchTerm) {
    commit(mutation.AUTOCOMPLETE_STARTED);
    try {
      const paging = {
        page: 1,
        rowsPerPage: 50,
        sortBy: "Name",
        descending: false
      };
      const criteria =
        searchTerm && ruleHelper.integer(searchTerm) === true ? { providerCode: searchTerm } : { name: searchTerm };
      const url = tableHelper.constructUrl("/api/providers", paging, criteria);
      const { data } = await axios.get(url);
      commit(mutation.AUTOCOMPLETE_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.AUTOCOMPLETE_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.EXPORT]({ commit, state }) {
    commit(mutation.EXPORT_STARTED);
    try {
      await axios.get(tableHelper.constructUrl("/api/exports/validate/providers", state.listing.criteria));
      commit(SHOW_NOTIFICATION, "Your export will commence shortly.");
      const url = tableHelper.constructUrl(`/api/exports/providers`, state.listing.criteria);
      tableHelper.downloadExportedSpreadsheet(url);
      commit(mutation.EXPORT_SUCCEEDED);
      return true;
    } catch (e) {
      commit(mutation.EXPORT_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.VIEW]({ commit, state }, providerId) {
    commit(mutation.VIEW_STARTED, providerId);
    try {
      const url = `/api/providers/${providerId}`;
      const { data } = await axios.get(url);
      commit(mutation.VIEW_SUCCEEDED, data);
      const index = tableHelper.getIndexOfId(state.listing, state.view.data.id);
      commit(mutation.VIEW_NEXT, tableHelper.getNextRecordInfo(index, state.listing));
      commit(mutation.VIEW_PREVIOUS, tableHelper.getPreviousRecordInfo(index, state.listing));
      return true;
    } catch (e) {
      commit(mutation.VIEW_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.SAP_TEST_READING]({ commit }, { providerId, levyCollectionType }) {
    commit(mutation.SAP_TEST_READING_STARTED);
    try {
      const url = `/api/system-diagnostics/sap-connections?providerId=${providerId}&levyCollectionType=${levyCollectionType}`;
      const { data } = await axios.get(url);
      commit(mutation.SAP_TEST_READING_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.SAP_TEST_READING_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.SAP_TEST_WRITING]({ commit }, { providerId, levyCollectionType }) {
    commit(mutation.SAP_TEST_WRITING_STARTED);
    try {
      const { data } = await axios.post("/api/system-diagnostics/sap-connections", { providerId, levyCollectionType });
      commit(mutation.SAP_TEST_WRITING_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.SAP_TEST_WRITING_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.RISK_PROFILE_HELP]({ commit }, providerId) {
    commit(mutation.RISK_PROFILE_HELP_STARTED, providerId);
    try {
      const url = `/api/providers/${providerId}/statistics/risk-profile?levyCollectionType=Help`;
      const { data } = await axios.get(url);
      commit(mutation.RISK_PROFILE_HELP_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.RISK_PROFILE_HELP_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.RISK_PROFILE_UPFRONT]({ commit }, providerId) {
    commit(mutation.RISK_PROFILE_UPFRONT_STARTED, providerId);
    try {
      const url = `/api/providers/${providerId}/statistics/risk-profile?levyCollectionType=Upfront`;
      const { data } = await axios.get(url);
      commit(mutation.RISK_PROFILE_UPFRONT_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.RISK_PROFILE_UPFRONT_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.RISK_PROFILE_VSL]({ commit }, providerId) {
    commit(mutation.RISK_PROFILE_VSL_STARTED, providerId);
    try {
      const url = `/api/providers/${providerId}/statistics/risk-profile?levyCollectionType=Vsl`;
      const { data } = await axios.get(url);
      commit(mutation.RISK_PROFILE_VSL_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.RISK_PROFILE_VSL_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  }
};
